export default "__VITE_ASSET__5ZZKZO5k__"